import { Paper } from '@mui/material';
import { ParametresManagement } from '../components/Tables/ParametresManagement';

interface ParametresProps {

}

function Parametres(ParametresProps: ParametresProps) {

    return (
        <>
            <Paper elevation={0} sx={{padding: 2}}>
                <ParametresManagement/>
            </Paper>
        </>
    );
}

export default Parametres;